import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import './SharedTablesView.css';

const SharedTablesView = ({ onSelectTable, onClose, visibleSharedTableIds = [] }) => {
  const { token } = useAuth();
  const [sharedTables, setSharedTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  useEffect(() => {
    fetchSharedTables();
  }, []);

  const fetchSharedTables = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/shared-tables`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch shared tables');
      }

      const data = await response.json();
      setSharedTables(data);
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shared-tables-overlay" onClick={onClose}>
      <div className="shared-tables-panel" onClick={(e) => e.stopPropagation()}>
        <div className="shared-tables-header">
          <h2>Tables Shared With Me</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="shared-tables-content">
          {loading && <div className="loading">Loading shared tables...</div>}
          {error && <div className="error-message">{error}</div>}

          {!loading && !error && sharedTables.length === 0 && (
            <div className="no-tables">
              <p>No tables have been shared with you yet.</p>
            </div>
          )}

          {!loading && !error && sharedTables.length > 0 && (
            <div className="tables-grid">
              {sharedTables.map((item) => {
                const isInView = visibleSharedTableIds.includes(item.table.id);
                return (
                  <div
                    key={item.share_id}
                    className={`shared-table-card ${isInView ? 'in-view' : ''}`}
                    onClick={() => {
                      onSelectTable(item);
                      onClose();
                    }}
                  >
                    <div className="table-card-header">
                      <h3>{item.table.name}</h3>
                      <span className={`permission-badge ${item.permission}`}>
                        {item.permission === 'write' ? 'Can Edit' : 'Read Only'}
                      </span>
                    </div>
                    <div className="table-card-info">
                      <span className="owner-info">Shared by {item.owner_username}</span>
                      <span className="table-size">
                        {item.table.num_rows} rows × {item.table.num_cols} cols
                      </span>
                      {isInView && (
                        <span className="in-view-badge">Currently in View</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SharedTablesView;
